export const LOAN_PROCEEDS_CALCULATOR_MODAL = "LOAN_PROCEEDS_CALCULATOR_MODAL";
export const REFI_CASHOUT_CALCULATOR_MODAL = "REFI_CASHOUT_CALCULATOR_MODAL";
export const PREPAYMENT_CALCULATOR_MODAL = "PREPAYMENT_CALCULATOR_MODAL";
export const SUPPLEMENTAL_CALCULATOR_MODAL = "SUPPLEMENTAL_CALCULATOR_MODAL";
export const WHAT_IF_MODAL = "WHAT_IF_MODAL";
